import React from 'react'
import { Button } from 'primereact/button'; 
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
        

const SearchToolBar = ({ setAddItemDialogVisible, globalFilter, setGlobalFilter, searchPlaceholder, createLabel, handleInputChangeDBSearch }) => {
    

    const newPlaceHolder = `Search ${searchPlaceholder} ...`
    const newCreateLabel= `+ Create ${createLabel}`
    
    const rightTemplate = () => {

        return <>
            <div className="my-2">
                    <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText
                            type='search'
                            placeholder={ newPlaceHolder}
                            value={globalFilter}
                            onChange={(e) => {
                            setGlobalFilter(e.target.value);
                           if(handleInputChangeDBSearch)  handleInputChangeDBSearch(e.target.value)
                        }}
                        />  
                    </span>
                </div>
        </>
     }

    
    const leftTemplate = () => { 
        return <>
             <div>
                <Button
                    outlined
                    label={newCreateLabel }
                    className='p-2 px-3 text-sm'
                    onClick={ ()=>setAddItemDialogVisible(true)}
                  />
            </div>
        
        </>
    }

    const leftTemplateToRender = setAddItemDialogVisible && createLabel ? leftTemplate : null;

  return (
      <Toolbar className="mb-2 pt-1 pb-1"  end ={leftTemplateToRender}  start={rightTemplate }/>        
  )
}

export default SearchToolBar